const Loading = () => {
    return (
        <div className="col-span-12" style={{ color: "white" }}>
            Loading...
        </div>
    );
};

export default Loading;
